import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceService } from '../../../../services/authentication/auth-service.service';
@Component({
  selector: 'app-logout-modal',
  templateUrl: './logout-modal.component.html',
  styleUrls: ['./logout-modal.component.css'],
})
export class LogoutModalComponent {
  constructor(private router: Router, private aotService: AuthServiceService) {}

  async logoutConfirmation() {
    await this.aotService.logOut();
    this.router.navigate(['/login']);
  }
}
